import { debug } from "util";

function initialState() {
  return {
    userIdAccountId: "",
    cookieKey: setCookieKey()
  };
}

const state = initialState();

function setCookieKey() {
  let key = "dev:filters";
  if (location.hostname === "stage-cxm.autoalert.com") {
    key = "stage:filters";
  } else if (location.hostname === "cxm.autoalert.com") {
    key = "prod:filters";
  } else if (location.hostname === "localhost") {
    key = "localhost:filters";
  }
  return key;
}

const getters = {
  cookieKey(state) {
    return state.cookieKey;
  },
  cookieSavedFilters(state) {
    if (document.cookie && document.cookie.length > 0) {
      let cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        let pair = cookies[i].split("=");
        let [k, value] = pair;
        if (k.trim() === state.cookieKey.trim()) {
          try {
            return JSON.parse(decodeURIComponent(value));
          } catch (e) {}
        } else {
          return null;
        }
      }
    }
  },
  userIdAccountId(state) {
    return state.userIdAccountId;
  }
};

const actions = {
  setUserIdAccountId(context, userIdAccountId) {
    context.commit("userIdAccountId", userIdAccountId);
  },
  setFilterCookie(context) {
    let savedFilters = context.getters.savedFilters;
    context.commit("setFilterCookie", savedFilters);
  },
  getFilterCookie(context, userIdAccountId) {
    // TODO: Post NADA, clean up all old code
    if (document.cookie && document.cookie.length > 0) {
      let cookies = document.cookie.split(";");
      let cookie = null;
      for (let i = 0; i < cookies.length; i++) {
        let pair = cookies[i].split("=");
        let [k, value] = pair;
        if (k.trim() === context.getters.cookieKey.trim()) {
          try {
            if (value) {
              cookie = JSON.parse(decodeURIComponent(value));
              if (cookie.userIdAccountId !== userIdAccountId) {
                context.commit("clearFilterCookie");
                cookie = null;
              } else {
                cookie = cookie.filters;
              }
            }
          } catch (e) {}
        }
      }
      return cookie;
    }
    return null;
  },
  clearFilterCookie(context) {
    context.commit("clearFilterCookie");
  }
};

const mutations = {
  userIdAccountId(state, userIdAccountId) {
    state.userIdAccountId = userIdAccountId;
  },
  setCookieKey(state, key) {
    state.cookieKey = key;
  },
  setFilterCookie(state, savedFilters) {
    try {
      if (savedFilters === null) {
        return;
      }
      let cookieData = {
        userIdAccountId: state.userIdAccountId,
        filters: savedFilters
      };
      let cookieSafeValue = encodeURIComponent(JSON.stringify(cookieData));

      let now = new Date();
      let time = now.getTime();
      let expireTime = time + 600;
      now.setTime(expireTime);
      let cookieValue =
        state.cookieKey +
        "=" +
        cookieSafeValue +
        ";expires=" +
        now.toISOString();
      document.cookie = cookieValue;
    } catch (err) {
      console.log("Error setting cookieKey cookie: ", err);
    }
  },
  clearFilterCookie(state) {
    let now = new Date();
    let time = now.getTime();
    let expireTime = time - 600;
    now.setTime(expireTime);
    document.cookie = state.cookieKey + "= " + ";expires=" + now.toISOString();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/Cookie.js